// extracted by mini-css-extract-plugin
export default {"root":"ErrorCard_root__2MC9e","root_toast":"ErrorCard_root_toast__cxQpq"};